<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">

                    <div class="card-header">
                    <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                    &nbsp;&nbsp;&nbsp;
                    <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("billing_detail_txt") }}</h6>
                    <button
                        class="btn btn-light float-end"
                        type="button"
                        data-bs-toggle="collapse" 
                        data-bs-target="#collapseExample" 
                        aria-expanded="false" 
                        aria-controls="collapseExample"
                    >
                        <i class="link-icon" data-feather="info"></i>
                        Audit Info
                    </button>

                    <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                        <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                        <p class="text-muted">{{this.forms.addwho}}</p>
                        </div>

                        <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Created At:</label>
                        <p class="text-muted">{{this.forms.adddate}}</p>
                        </div>

                        <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                        <p class="text-muted">{{this.forms.editwho}}</p>
                        </div>

                        <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                        <p class="text-muted">{{this.forms.editdate}}</p>
                        </div>

                        
                        
                    </div>

                    </div>

                    <div class="card-body">

                        <div class="row mb-3">
                            <div class="col">
                            <label class="form-label">{{$t('billingId')}}</label>
                            <input
                                type="text"
                                class="form-control"
                                id="billingId"
                                :placeholder="$t('billingId')"
                                v-model="forms.idBillingHeader"
                                disabled
                                />
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col">
                            <label class="form-label">{{$t('customerId')}}</label>
                            <input
                                type="text"
                                class="form-control"
                                id="customerId"
                                :placeholder="$t('customerId')"
                                v-model="forms.customerId"
                                disabled
                                />
                            </div>
                            <div class="col-md-6">
                            <label class="form-label">{{
                                $t('warehouseId_txt')
                                }}</label>
                                <input
                                type="text"
                                class="form-control"
                                id="warehouseId"
                                :placeholder="$t('warehouseId_txt')"
                                v-model="forms.warehouseId"
                                disabled
                                />
                            </div>
                        </div>
            
                        <div class="row mb-3">
                            <div class="col">
                                                    <label class="form-label">{{$t('customerGroup')}}</label>
                                                    <input
                                type="text"
                                class="form-control"
                                id="customerGroup"
                                :placeholder="$t('customerGroup')"
                                v-model="forms.customerGroup"
                                disabled
                                />
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="form-label">{{
                                $t('customerSAPCode')
                                }}</label>
                                <input
                                type="text"
                                class="form-control"
                                id="customerSAPCode"
                                :placeholder="$t('customerSAPCode')"
                                v-model="forms.customerSAPCode"
                                disabled
                                />
                                                </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col">
                            <br>
                            <button
                            class="btn btn-light float-first"
                            type="button"
                            @click="getRateDetail()"
                        >
                            <i class="link-icon" data-feather="info"></i>
                            {{ $t("rate_detail_txt") }}
                        </button>
                        
                            </div>
                            <div class="col-md-6">
                            <label class="form-label">{{
                                $t('transactionDate_txt')
                                }}</label>
                                <input
                                type="text"
                                class="form-control"
                                id="transactionDate"
                                :placeholder="$t('transactionDate_txt')"
                                v-model="forms.transactionDate"
                                disabled
                                />
                            </div>
                        </div>
                
                        <div class="row mb-3">
                            <div class="col">
                                                    <label class="form-label">{{$t('statusTxt')}}</label>
                                                    <input
                                type="text"
                                class="form-control"
                                id="status"
                                :placeholder="$t('statusTxt')"
                                v-model="forms.status"
                                disabled
                                />
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="form-label">{{
                                $t('amount_txt')
                                }}</label>
                                <input
                                type="text"
                                class="form-control"
                                id="amount"
                                :placeholder="$t('amount_txt')"
                                v-model="amountData"
                                disabled
                                />
                                                </div>
                        </div>
    


                        <div class="card-header">
                                <br>
                                <br>
                                
                            &nbsp;&nbsp;&nbsp;
                            <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("billing_category_detail_txt") }}</h6>
                        </div>

                
                        <div class="row mb-3">
                            <div class="col">
                                <label class="form-label">{{$t('chargeCategory_txt')}}</label>
                                <input  type="text" class="form-control" id="status" :placeholder="$t('chargeCategory_txt')" v-model="billingDetail.chargeCategory" disabled />
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">{{ $t('chargeType_txt') }}</label>
                                <input type="text" class="form-control" id="chargeType" :placeholder="$t('chargeType_txt')" v-model="billingDetail.chargeType" disabled />
                            </div>
                        </div>

                
                        <div class="row mb-3">
                            <div class="col">
                                <label class="form-label">{{$t('amountCategory')}}</label>
                                <input  type="text" class="form-control" id="status" :placeholder="$t('amountCategory')" v-model="amountCategory" disabled />
                            </div>
                        </div>


                        <div class="card-header">
                                <br>
                                <br>
                                
                            &nbsp;&nbsp;&nbsp;
                            <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("billing_sub_detail_txt") }} {{this.billingDetail.chargeCategory}}</h6>
                        </div>

                        <div class="row mb-3" v-if="forms.status == 'COMPLETED' && chargeCategory == 'VAS'">
                          <label class="form-label">
                                <!-- <button v-if="permision_role.method_upload && chargeCategory == 'VAS' && forms.status == 'PROCESSING' || permision_role.method_upload && chargeCategory == 'VAS' &&  forms.status == 'COMPLETED'"
                                    class="btn btn-warning float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="uploadVas()"
                                >
                                <i class="mdi mdi-cloud-upload" style="font-size:16px"></i>
                                    {{ $t("UploadTxt") }} .xlsx
                                </button>     -->
                           
                                <button
                                    class="btn btn-success float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="downloadDataVas()"
                                >
                                    <i class="mdi mdi-cloud-download" style="font-size:16px"></i>
                                    {{ $t("downloadData") }} .xlsx
                                </button>    
                            </label>
                            
                            <div class="card-body">

                              <vue-good-table
                                title="list-billing-detail-vas"
                                ref="list-billing-detail-vas"
                                :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                                mode="remote"
                                @on-selected-rows-change="selectionChangedVas"
                                @on-page-change="onPageChangeVas"
                                @on-sort-change="onSortChangeVas"
                                @on-column-filter="onColumnFilterVas"
                                @on-per-page-change="onPerPageChangeVas"
                                :totalRows="totalVasRecords"
                                :line-numbers="true"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                  enabled: true,
                                  perPageDropdown: [10, 50, 100, 1000, 10000],
                                  dropdownAllowAll: false,
                                }"
                                :rows="rowsVas"
                                :columns="columnsVas"
                              >
                                <div slot="table-actions">
                                    {{ $t("no_select_data") }}
                                </div>
                                <div slot="selected-row-actions">
                                    <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="vasChangeStatus"> <i
                                        class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                    <button class="btn btn-success btn-xs" @click="removeVasIds"><i class="mdi mdi-close"></i> {{
                                        $t("unselect_data_txt")
                                    }} </button>
                                </div>

                              <template slot="column-filter" slot-scope="{ column }">
                                <span v-if="column.filterOptions.customFilter">

                                  <span v-if="column.field =='receiveDate'">

                                    <date-range-picker style="width:100%" @update="receiveDateVasChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="receiveDateVasRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                      <div slot="header" slot-scope="header" class="slot">
                                        <a @click="clearreceiveDateVasChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                        <br>
                                      </div>
                                    </date-range-picker>

                                  </span>
                                
                                </span>
                                

                              </template>

                              </vue-good-table>


                            </div>
                            

                        </div>
                        <div class="row mb-3" v-else-if="forms.status != 'COMPLETED' && chargeCategory == 'VAS'">
                               
                          <label class="form-label">
                                <button
                                    class="btn btn-success float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="downloadDataVas()"
                                >
                                    <i class="mdi mdi-cloud-download" style="font-size:16px"></i>
                                    {{ $t("downloadData") }} .xlsx
                                </button> 
                          </label>   
                             
 


                            <div class="card-body">

                              <vue-good-table
                                title="list-billing-detail-vas"
                                ref="list-billing-detail-vas"
                                :select-options="{enabled: false, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                                mode="remote"
                                @on-selected-rows-change="selectionChangedVas"
                                @on-page-change="onPageChangeVas"
                                @on-sort-change="onSortChangeVas"
                                @on-column-filter="onColumnFilterVas"
                                @on-per-page-change="onPerPageChangeVas"
                                :totalRows="totalVasRecords"
                                :line-numbers="true"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                  enabled: true,
                                  perPageDropdown: [10, 50, 100, 1000, 10000],
                                  dropdownAllowAll: false,
                                }"
                                :rows="rowsVas"
                                :columns="columnsVas"
                              >
                                <div slot="table-actions">
                                    {{ $t("no_select_data") }}
                                </div>
                                <div slot="selected-row-actions">
                                    <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="vasChangeStatus"> <i
                                        class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                    <button class="btn btn-success btn-xs" @click="removeVasIds"><i class="mdi mdi-close"></i> {{
                                        $t("cancel_order_txt")
                                    }} </button>
                                </div>

                                <template slot="column-filter" slot-scope="{ column }">
                                  <span v-if="column.filterOptions.customFilter">

                                    <span v-if="column.field =='receiveDate'">

                                      <date-range-picker style="width:100%" @update="receiveDateVasChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="receiveDateVasRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                        <div slot="header" slot-scope="header" class="slot">
                                          <a @click="clearreceiveDateVasChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                          <br>
                                        </div>
                                      </date-range-picker>

                                    </span>
                                  
                                  </span>
                                  

                                </template>


                              </vue-good-table>


                            </div>
                            

                        </div>
                        <div class="row mb-3" v-else-if="forms.status == 'COMPLETED' && chargeCategory == 'OVERTIME'">
                           
                            <label class="form-label">
                              <!-- <button v-if="permision_role.method_upload && chargeCategory == 'OVERTIME' && forms.status == 'PROCESSING' || permision_role.method_upload && chargeCategory == 'OVERTIME' &&  forms.status == 'COMPLETED'"
                                    class="btn btn-warning float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="uploadOvertime()"
                                >
                                <i class="mdi mdi-cloud-upload" style="font-size:16px"></i>
                                    {{ $t("UploadTxt") }} .xlsx
                                </button>   -->

                                <button
                                    class="btn btn-success float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="downloadDataOvertime()"
                                >
                                <i class="mdi mdi-cloud-download" style="font-size:16px"></i>
                                    {{ $t("downloadData") }} .xlsx
                                </button>    
                            </label>
                            <div class="card-body">

                              <vue-good-table
                                title="list-billing-detail-overtime"
                                ref="list-billing-detail-overtime"
                                :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                                mode="remote"
                                @on-selected-rows-change="selectionChangedOvertime"
                                @on-page-change="onPageChangeOvertime"
                                @on-sort-change="onSortChangeOvertime"
                                @on-column-filter="onColumnFilterOvertime"
                                @on-per-page-change="onPerPageChangeOvertime"
                                :totalRows="totalOvertimeRecords"
                                :line-numbers="true"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                  enabled: true,
                                  perPageDropdown: [10, 50, 100, 1000, 10000],
                                  dropdownAllowAll: false,
                                }"
                                :rows="rowsOvertime"
                                :columns="columnsOvertime"
                            >

                            <div slot="table-actions">
                                {{ $t("no_select_data") }}
                            </div>
                            <div slot="selected-row-actions">
                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="OvertimeChangeStatus"> <i class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                <button class="btn btn-success btn-xs" @click="removeOvertimeIds"><i class="mdi mdi-close"></i> {{ $t("unselect_data_txt") }} </button>
                            </div>


                            <template slot="column-filter" slot-scope="{ column }">
                              <span v-if="column.filterOptions.customFilter">

                                <span v-if="column.field =='startOvertime'">

                                  <date-range-picker style="width:100%" @update="startOvertimeChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="startOvertimeRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                    <div slot="header" slot-scope="header" class="slot">
                                      <a @click="clearstartOvertimeChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                      <br>
                                    </div>
                                  </date-range-picker>

                                </span>
                              
                                <span v-if="column.field =='endOvertime'">

                                <date-range-picker style="width:100%" @update="endOvertimeChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="endOvertimeRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                  <div slot="header" slot-scope="header" class="slot">
                                    <a @click="clearendOvertimeChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                    <br>
                                  </div>
                                </date-range-picker>

                                </span>
                                
                              </span>
                              

                            </template>


                            </vue-good-table>


                            </div>
                           


                        </div>
                        <div class="row mb-3" v-else-if="forms.status != 'COMPLETED' && chargeCategory == 'OVERTIME'">

                            <label class="form-label">
                              <button class="btn btn-success float-end btn-xs" style="margin-right: 5px" @click.prevent="downloadDataOvertime()" >
                                <i class="mdi mdi-cloud-download" style="font-size:16px"></i>
                                {{ $t("downloadData") }} .xlsx
                              </button>    
                            </label>

                            <div class="card-body">

                              <vue-good-table
                                title="list-billing-detail-overtime"
                                ref="list-billing-detail-overtime"
                                :select-options="{enabled: false, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                                mode="remote"
                                @on-selected-rows-change="selectionChangedOvertime"
                                @on-page-change="onPageChangeOvertime"
                                @on-sort-change="onSortChangeOvertime"
                                @on-column-filter="onColumnFilterOvertime"
                                @on-per-page-change="onPerPageChangeOvertime"
                                :totalRows="totalOvertimeRecords"
                                :line-numbers="true"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                  enabled: true,
                                  perPageDropdown: [10, 50, 100, 1000, 10000],
                                  dropdownAllowAll: false,
                                }"
                                :rows="rowsOvertime"
                                :columns="columnsOvertime"
                            >

                            <div slot="table-actions">
                                {{ $t("no_select_data") }}
                            </div>
                            <div slot="selected-row-actions">
                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="OvertimeChangeStatus"> <i
                                    class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                <button class="btn btn-success btn-xs" @click="removeOvertimeIds"><i class="mdi mdi-close"></i> {{
                                    $t("unselect_data_txt")
                                }} </button>
                            </div>

                            <template slot="column-filter" slot-scope="{ column }">
                              <span v-if="column.filterOptions.customFilter">

                                <span v-if="column.field =='startOvertime'">

                                  <date-range-picker style="width:100%" @update="startOvertimeChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="startOvertimeRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                    <div slot="header" slot-scope="header" class="slot">
                                      <a @click="clearstartOvertimeChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                      <br>
                                    </div>
                                  </date-range-picker>

                                </span>
                              
                                <span v-if="column.field =='endOvertime'">

                                <date-range-picker style="width:100%" @update="endOvertimeChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="endOvertimeRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                  <div slot="header" slot-scope="header" class="slot">
                                    <a @click="clearendOvertimeChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                    <br>
                                  </div>
                                </date-range-picker>

                                </span>
                                
                              </span>
                              

                            </template>

                            </vue-good-table>


                            </div>


                        </div>
                        <div class="row mb-3" v-else-if="forms.status == 'COMPLETED' && chargeCategory == 'FIX CHARGE' || forms.status == 'COMPLETED' && chargeCategory == 'FIXED CHARGE'">

                            <label class="form-label">
                                <button
                                    class="btn btn-success float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="downloadDataFixCharge()"
                                >
                                    <i class="link-icon" data-feather="download"></i>
                                    {{ $t("downloadData") }} .xlsx
                                </button>    
                            </label>

                            <div class="card-body">
                              <vue-good-table
                                title="list-billing-detail-FixCharge"
                                ref="list-billing-detail-FixCharge"
                                :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                                mode="remote"
                                @on-selected-rows-change="selectionChangedFixCharge"
                                @on-page-change="onPageChangeFixCharge"
                                @on-sort-change="onSortChangeFixCharge"
                                @on-column-filter="onColumnFilterFixCharge"
                                @on-per-page-change="onPerPageChangeFixCharge"
                                :totalRows="totalFixChargeRecords"
                                :line-numbers="true"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                  enabled: true,
                                  perPageDropdown: [10, 50, 100, 1000, 10000],
                                  dropdownAllowAll: false,
                                }"
                                :rows="rowsFixCharge"
                                :columns="columnsFixCharge"
                            >

                            <div slot="table-actions">
                                {{ $t("no_select_data") }}
                            </div>
                            <div slot="selected-row-actions">
                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="FixChargeChangeStatus"> <i
                                    class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                <button class="btn btn-success btn-xs" @click="removeFixChargeIds"><i class="mdi mdi-close"></i> {{
                                    $t("unselect_data_txt")
                                }} </button>
                            </div>

                            </vue-good-table>

                            </div>
                           


                        </div>
                        <div class="row mb-3" v-else-if="forms.status != 'COMPLETED' && chargeCategory == 'FIX CHARGE' || forms.status != 'COMPLETED' && chargeCategory == 'FIXED CHARGE'">

                            <label class="form-label">
                                <button
                                    class="btn btn-success float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="downloadDataFixCharge()"
                                >
                                    <i class="link-icon" data-feather="download"></i>
                                    {{ $t("downloadData") }} .xlsx
                                </button>    
                            </label>

                            <div class="card-body">
                              <vue-good-table
                                title="list-billing-detail-FixCharge"
                                ref="list-billing-detail-FixCharge"
                                :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                                mode="remote"
                                @on-selected-rows-change="selectionChangedFixCharge"
                                @on-page-change="onPageChangeFixCharge"
                                @on-sort-change="onSortChangeFixCharge"
                                @on-column-filter="onColumnFilterFixCharge"
                                @on-per-page-change="onPerPageChangeFixCharge"
                                :totalRows="totalFixChargeRecords"
                                :line-numbers="true"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                  enabled: true,
                                  perPageDropdown: [10, 50, 100, 1000, 10000],
                                  dropdownAllowAll: false,
                                }"
                                :rows="rowsFixCharge"
                                :columns="columnsFixCharge"
                            >

                            <div slot="table-actions">
                                {{ $t("no_select_data") }}
                            </div>
                            <div slot="selected-row-actions">
                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="FixChargeChangeStatus"> <i
                                    class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                <button class="btn btn-success btn-xs" @click="removeFixChargeIds"><i class="mdi mdi-close"></i> {{
                                    $t("unselect_data_txt")
                                }} </button>
                            </div>

                            </vue-good-table>

                            </div>


                        </div>
                        <div class="row mb-3" v-else-if="forms.status == 'COMPLETED' && chargeCategory == 'STORAGE'">

                            <label class="form-label">
                                <button
                                    class="btn btn-success float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="downloadDataStorage()"
                                >
                                    <i class="link-icon" data-feather="download"></i>
                                    {{ $t("downloadData") }} .xlsx
                                </button>    
                            </label>

                            <div class="card-body">


                              <vue-good-table
                                title="list-billing-detail-Storage"
                                ref="list-billing-detail-Storage"
                                :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                                mode="remote"
                                @on-selected-rows-change="selectionChangedStorage"
                                @on-page-change="onPageChangeStorage"
                                @on-sort-change="onSortChangeStorage"
                                @on-column-filter="onColumnFilterStorage"
                                @on-per-page-change="onPerPageChangeStorage"
                                :totalRows="totalStorageRecords"
                                :line-numbers="true"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                  enabled: true,
                                  perPageDropdown: [10, 50, 100, 1000, 10000],
                                  dropdownAllowAll: false,
                                }"
                                :rows="rowsStorage"
                                :columns="columnsStorage"
                              >

                              <div slot="table-actions">
                                  {{ $t("no_select_data") }}
                              </div>

                              <template slot="column-filter" slot-scope="{ column }">
                                <span v-if="column.filterOptions.customFilter">

                                  <span v-if="column.field =='stockDate'">

                                    <date-range-picker style="width:100%" @update="stockDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="stockDateRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                      <div slot="header" slot-scope="header" class="slot">
                                        <a @click="clearstockDateChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                        <br>
                                      </div>
                                    </date-range-picker>

                                  </span>
                                
                                </span>
                                

                              </template>

                              <div slot="selected-row-actions">
                                  <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="StorageChangeStatus"> <i
                                      class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                  <button class="btn btn-success btn-xs" @click="removeStorageIds"><i class="mdi mdi-close"></i> {{
                                      $t("unselect_data_txt")
                                  }} </button>
                              </div>

                              </vue-good-table>

                            </div>


                        </div>
                        <div class="row mb-3" v-else-if="forms.status != 'COMPLETED' && chargeCategory == 'STORAGE'">

                            <label class="form-label">
                                <button
                                    class="btn btn-success float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="downloadDataStorage()"
                                >
                                    <i class="link-icon" data-feather="download"></i>
                                    {{ $t("downloadData") }} .xlsx
                                </button>    
                            </label>

                            
                            <div class="card-body">


                              <vue-good-table
                                title="list-billing-detail-Storage"
                                ref="list-billing-detail-Storage"
                                :select-options="{enabled: false, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                                mode="remote"
                                @on-selected-rows-change="selectionChangedStorage"
                                @on-page-change="onPageChangeStorage"
                                @on-sort-change="onSortChangeStorage"
                                @on-column-filter="onColumnFilterStorage"
                                @on-per-page-change="onPerPageChangeStorage"
                                :totalRows="totalStorageRecords"
                                :line-numbers="true"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                  enabled: true,
                                  perPageDropdown: [10, 50, 100, 1000, 10000],
                                  dropdownAllowAll: false,
                                }"
                                :rows="rowsStorage"
                                :columns="columnsStorage"
                              >

                              <div slot="table-actions">
                                  {{ $t("no_select_data") }}
                              </div>

                              <template slot="column-filter" slot-scope="{ column }">
                                <span v-if="column.filterOptions.customFilter">

                                  <span v-if="column.field =='stockDate'">

                                    <date-range-picker style="width:100%" @update="stockDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="stockDateRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                      <div slot="header" slot-scope="header" class="slot">
                                        <a @click="clearstockDateChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                        <br>
                                      </div>
                                    </date-range-picker>

                                  </span>
                                
                                </span>
                                

                              </template>

                              <div slot="selected-row-actions">
                                  <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="StorageChangeStatus"> <i
                                      class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                  <button class="btn btn-success btn-xs" @click="removeStorageIds"><i class="mdi mdi-close"></i> {{
                                      $t("unselect_data_txt")
                                  }} </button>
                              </div>

                              </vue-good-table>

                            </div>

                        </div>
                        <div class="row mb-3" v-else-if="forms.status == 'COMPLETED' && chargeCategory == 'HANDLING IN'">

                          <label class="form-label">
                                <button
                                    class="btn btn-success float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="downloadDataHandlingIn()"
                                >
                                    <i class="link-icon" data-feather="download"></i>
                                    {{ $t("downloadData") }} .xlsx
                                </button>    
                            </label>

                            <div class="card-body">

                              <vue-good-table
                                title="list-billing-detail-HandlingIn"
                                ref="list-billing-detail-HandlingIn"
                                :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                                mode="remote"
                                @on-selected-rows-change="selectionChangedHandlingIn"
                                @on-page-change="onPageChangeHandlingIn"
                                @on-sort-change="onSortChangeHandlingIn"
                                @on-column-filter="onColumnFilterHandlingIn"
                                @on-per-page-change="onPerPageChangeHandlingIn"
                                :totalRows="totalHandlingInRecords"
                                :line-numbers="true"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                  enabled: true,
                                  perPageDropdown: [10, 50, 100, 1000, 10000],
                                  dropdownAllowAll: false,
                                }"
                                :rows="rowsHandlingIn"
                                :columns="columnsHandlingIn"
                            >

                            <div slot="table-actions">
                                {{ $t("no_select_data") }}
                            </div>
                            <div slot="selected-row-actions">
                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="HandlingInChangeStatus"> <i
                                    class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                <button class="btn btn-success btn-xs" @click="removeHandlingInIds"><i class="mdi mdi-close"></i> {{
                                    $t("unselect_data_txt")
                                }} </button>
                            </div>
                          
                            <template slot="column-filter" slot-scope="{ column }">
                              <span v-if="column.filterOptions.customFilter">

                                <span v-if="column.field =='receiveDate'">

                                  <date-range-picker style="width:100%" @update="receiveDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="receiveDateRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                    <div slot="header" slot-scope="header" class="slot">
                                      <a @click="clearreceiveDateChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                      <br>
                                    </div>
                                  </date-range-picker>

                                </span>
                              
                              </span>
                              

                            </template>

                            </vue-good-table>


                            </div>
                        

                        </div>
                        <div class="row mb-3" v-else-if="forms.status != 'COMPLETED' && chargeCategory == 'HANDLING IN'">

                          <label class="form-label">
                                <button
                                    class="btn btn-success float-end btn-xs"
                                    style="margin-right: 5px"
                                    @click.prevent="downloadDataHandlingIn()"
                                >
                                    <i class="link-icon" data-feather="download"></i>
                                    {{ $t("downloadData") }} .xlsx
                                </button>    
                            </label>

                           
                            <div class="card-body">

                              <vue-good-table
                                title="list-billing-detail-HandlingIn"
                                ref="list-billing-detail-HandlingIn"
                                :select-options="{enabled: false, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                                mode="remote"
                                @on-selected-rows-change="selectionChangedHandlingIn"
                                @on-page-change="onPageChangeHandlingIn"
                                @on-sort-change="onSortChangeHandlingIn"
                                @on-column-filter="onColumnFilterHandlingIn"
                                @on-per-page-change="onPerPageChangeHandlingIn"
                                :totalRows="totalHandlingInRecords"
                                :line-numbers="true"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                  enabled: true,
                                  perPageDropdown: [10, 50, 100, 1000, 10000],
                                  dropdownAllowAll: false,
                                }"
                                :rows="rowsHandlingIn"
                                :columns="columnsHandlingIn"
                            >

                            <div slot="table-actions">
                                {{ $t("no_select_data") }}
                            </div>
                            <div slot="selected-row-actions">
                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="HandlingInChangeStatus"> <i
                                    class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                                <button class="btn btn-success btn-xs" @click="removeHandlingInIds"><i class="mdi mdi-close"></i> {{
                                    $t("unselect_data_txt")
                                }} </button>
                            </div>

                              <template slot="column-filter" slot-scope="{ column }">
                                <span v-if="column.filterOptions.customFilter">

                                  <span v-if="column.field =='receiveDate'">

                                    <date-range-picker style="width:100%" @update="receiveDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="receiveDateRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                      <div slot="header" slot-scope="header" class="slot">
                                        <a @click="clearreceiveDateChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                        <br>
                                      </div>
                                    </date-range-picker>

                                  </span>
                                
                                </span>
                                

                              </template>

                            </vue-good-table>


                            </div>
                        

                        </div>
                        <div class="row mb-3" v-else-if="forms.status == 'COMPLETED' && chargeCategory == 'HANDLING OUT'">

                          <label class="form-label">
                            <button
                                class="btn btn-success float-end btn-xs"
                                style="margin-right: 5px"
                                @click.prevent="downloadDataHandlingOut()"
                            >
                                <i class="link-icon" data-feather="download"></i>
                                {{ $t("downloadData") }} .xlsx
                            </button>    
                        </label>

                        <div class="card-body">


                          <vue-good-table
                            title="list-billing-detail-HandlingOut"
                            ref="list-billing-detail-HandlingOut"
                            :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                            mode="remote"
                            @on-selected-rows-change="selectionChangedHandlingOut"
                            @on-page-change="onPageChangeHandlingOut"
                            @on-sort-change="onSortChangeHandlingOut"
                            @on-column-filter="onColumnFilterHandlingOut"
                            @on-per-page-change="onPerPageChangeHandlingOut"
                            :totalRows="totalHandlingOutRecords"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :pagination-options="{
                              enabled: true,
                              perPageDropdown: [10, 50, 100, 1000, 10000],
                              dropdownAllowAll: false,
                            }"
                            :rows="rowsHandlingOut"
                            :columns="columnsHandlingOut"
                          >

                          <div slot="table-actions">
                              {{ $t("no_select_data") }}
                          </div>
                          <div slot="selected-row-actions">
                              <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="HandlingOutChangeStatus"> <i
                                  class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                              <button class="btn btn-success btn-xs" @click="removeHandlingOutIds"><i class="mdi mdi-close"></i> {{
                                  $t("unselect_data_txt")
                              }} </button>
                          </div>

                          <template slot="column-filter" slot-scope="{ column }">
                            <span v-if="column.filterOptions.customFilter">

                              <span v-if="column.field =='shipmentDate'">

                                <date-range-picker style="width:100%" @update="shipmentDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="shipmentDateRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                  <div slot="header" slot-scope="header" class="slot">
                                    <a @click="clearshipmentDateChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                    <br>
                                  </div>
                                </date-range-picker>

                              </span>
                            
                            </span>
                            

                          </template>
                          
                          </vue-good-table>


                        </div>
                        

                        </div>
                        <div class="row mb-3" v-else-if="forms.status != 'COMPLETED' && chargeCategory == 'HANDLING OUT'">

                          <label class="form-label">
                            <button
                                class="btn btn-success float-end btn-xs"
                                style="margin-right: 5px"
                                @click.prevent="downloadDataHandlingOut()"
                            >
                                <i class="link-icon" data-feather="download"></i>
                                {{ $t("downloadData") }} .xlsx
                            </button>    
                        </label>

             
                        <div class="card-body">


                          <vue-good-table
                            title="list-billing-detail-HandlingOut"
                            ref="list-billing-detail-HandlingOut"
                            :select-options="{enabled: false, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                            mode="remote"
                            @on-selected-rows-change="selectionChangedHandlingOut"
                            @on-page-change="onPageChangeHandlingOut"
                            @on-sort-change="onSortChangeHandlingOut"
                            @on-column-filter="onColumnFilterHandlingOut"
                            @on-per-page-change="onPerPageChangeHandlingOut"
                            :totalRows="totalHandlingOutRecords"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :pagination-options="{
                              enabled: true,
                              perPageDropdown: [10, 50, 100, 1000, 10000],
                              dropdownAllowAll: false,
                            }"
                            :rows="rowsHandlingOut"
                            :columns="columnsHandlingOut"
                          >

                          <div slot="table-actions">
                              {{ $t("no_select_data") }}
                          </div>
                          <div slot="selected-row-actions">
                              <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="HandlingOutChangeStatus"> <i
                                  class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                              <button class="btn btn-success btn-xs" @click="removeHandlingOutIds"><i class="mdi mdi-close"></i> {{
                                  $t("unselect_data_txt")
                              }} </button>
                          </div>

                          <template slot="column-filter" slot-scope="{ column }">
                            <span v-if="column.filterOptions.customFilter">

                              <span v-if="column.field =='shipmentDate'">

                                <date-range-picker style="width:100%" @update="shipmentDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="shipmentDateRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                  <div slot="header" slot-scope="header" class="slot">
                                    <a @click="clearshipmentDateChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                    <br>
                                  </div>
                                </date-range-picker>

                              </span>
                            
                            </span>
                            

                          </template>

                          </vue-good-table>


                        </div>
                        

                        </div>
                        <div class="row mb-3" v-else-if="forms.status == 'COMPLETED' && chargeCategory == 'MINIMUM CHARGE'">

                          <label class="form-label">
                            <button
                                class="btn btn-success float-end btn-xs"
                                style="margin-right: 5px"
                                @click.prevent="downloadDataMinimumCharge()"
                            >
                                <i class="link-icon" data-feather="download"></i>
                                {{ $t("downloadData") }} .xlsx
                            </button>    
                        </label>

                        <div class="card-body">


                          <vue-good-table
                            title="list-billing-detail-MinimumCharge"
                            ref="list-billing-detail-MinimumCharge"
                            :select-options="{enabled: false, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                            mode="remote"
                            @on-selected-rows-change="selectionChangedMinimumCharge"
                            @on-page-change="onPageChangeMinimumCharge"
                            @on-sort-change="onSortChangeMinimumCharge"
                            @on-column-filter="onColumnFilterMinimumCharge"
                            @on-per-page-change="onPerPageChangeMinimumCharge"
                            :totalRows="totalMinimumChargeRecords"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :pagination-options="{
                              enabled: true,
                              perPageDropdown: [10, 50, 100, 1000, 10000],
                              dropdownAllowAll: false,
                            }"
                            :rows="rowsMinimumCharge"
                            :columns="columnsMinimumCharge"
                        >

                        <div slot="table-actions">
                            {{ $t("no_select_data") }}
                        </div>
                        <div slot="selected-row-actions">
                            <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="MinimumChargeChangeStatus"> <i
                                class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                            <button class="btn btn-success btn-xs" @click="removeMinimumChargeIds"><i class="mdi mdi-close"></i> {{
                                $t("unselect_data_txt")
                            }} </button>
                        </div>

                        </vue-good-table>


                        </div>

                        </div>
                        <div class="row mb-3" v-else-if="forms.status != 'COMPLETED' && chargeCategory == 'MINIMUM CHARGE'">

                          <label class="form-label">
                            <button
                                class="btn btn-success float-end btn-xs"
                                style="margin-right: 5px"
                                @click.prevent="downloadDataMinimumCharge()"
                            >
                                <i class="link-icon" data-feather="download"></i>
                                {{ $t("downloadData") }} .xlsx
                            </button>    
                        </label>

                   
                        <div class="card-body">


                          <vue-good-table
                            title="list-billing-detail-MinimumCharge"
                            ref="list-billing-detail-MinimumCharge"
                            :select-options="{enabled: false, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                            mode="remote"
                            @on-selected-rows-change="selectionChangedMinimumCharge"
                            @on-page-change="onPageChangeMinimumCharge"
                            @on-sort-change="onSortChangeMinimumCharge"
                            @on-column-filter="onColumnFilterMinimumCharge"
                            @on-per-page-change="onPerPageChangeMinimumCharge"
                            :totalRows="totalMinimumChargeRecords"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :pagination-options="{
                              enabled: true,
                              perPageDropdown: [10, 50, 100, 1000, 10000],
                              dropdownAllowAll: false,
                            }"
                            :rows="rowsMinimumCharge"
                            :columns="columnsMinimumCharge"
                        >

                        <div slot="table-actions">
                            {{ $t("no_select_data") }}
                        </div>
                        <div slot="selected-row-actions">
                            <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="MinimumChargeChangeStatus"> <i
                                class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                            <button class="btn btn-success btn-xs" @click="removeMinimumChargeIds"><i class="mdi mdi-close"></i> {{
                                $t("unselect_data_txt")
                            }} </button>
                        </div>

                        </vue-good-table>


                        </div>

                        </div>
                        <div class="row mb-3" v-else-if="forms.status == 'COMPLETED' && chargeCategory == 'PACKAGING MATERIAL'">

                          <label class="form-label">
                            <button
                                class="btn btn-success float-end btn-xs"
                                style="margin-right: 5px"
                                @click.prevent="downloadDataPackagingMaterial()"
                            >
                                <i class="link-icon" data-feather="download"></i>
                                {{ $t("downloadData") }} .xlsx
                            </button>    
                        </label>

                        <div class="card-body">


                          <vue-good-table
                            title="list-billing-detail-PackagingMaterial"
                            ref="list-billing-detail-PackagingMaterial"
                            :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                            mode="remote"
                            @on-selected-rows-change="selectionChangedPackagingMaterial"
                            @on-page-change="onPageChangePackagingMaterial"
                            @on-sort-change="onSortChangePackagingMaterial"
                            @on-column-filter="onColumnFilterPackagingMaterial"
                            @on-per-page-change="onPerPageChangePackagingMaterial"
                            :totalRows="totalPackagingMaterialRecords"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :pagination-options="{
                              enabled: true,
                              perPageDropdown: [10, 50, 100, 1000, 10000],
                              dropdownAllowAll: false,
                            }"
                            :rows="rowsPackagingMaterial"
                            :columns="columnsPackagingMaterial"
                          >

                          <div slot="table-actions">
                              {{ $t("no_select_data") }}
                          </div>
                          <div slot="selected-row-actions">
                              <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="PackagingMaterialChangeStatus"> <i
                                  class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                              <button class="btn btn-success btn-xs" @click="removePackagingMaterialIds"><i class="mdi mdi-close"></i> {{
                                  $t("unselect_data_txt")
                              }} </button>
                          </div>

                          <template slot="column-filter" slot-scope="{ column }">
                            <span v-if="column.filterOptions.customFilter">

                              <span v-if="column.field =='shipmentDate'">

                                <date-range-picker style="width:100%" @update="shipmentDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="shipmentDateRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                  <div slot="header" slot-scope="header" class="slot">
                                    <a @click="clearshipmentDateChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                    <br>
                                  </div>
                                </date-range-picker>

                              </span>
                            
                            </span>
                            

                          </template>

                          </vue-good-table>


                        </div>
                        

                        </div>
                        <div class="row mb-3" v-else-if="forms.status != 'COMPLETED' && chargeCategory == 'PACKAGING MATERIAL'">

                          <label class="form-label">
                            <button
                                class="btn btn-success float-end btn-xs"
                                style="margin-right: 5px"
                                @click.prevent="downloadDataPackagingMaterial()"
                            >
                                <i class="link-icon" data-feather="download"></i>
                                {{ $t("downloadData") }} .xlsx
                            </button>    
                        </label>

             
                        <div class="card-body">


                          <vue-good-table
                            title="list-billing-detail-PackagingMaterial"
                            ref="list-billing-detail-PackagingMaterial"
                            :select-options="{enabled: false, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                            mode="remote"
                            @on-selected-rows-change="selectionChangedPackagingMaterial"
                            @on-page-change="onPageChangePackagingMaterial"
                            @on-sort-change="onSortChangePackagingMaterial"
                            @on-column-filter="onColumnFilterPackagingMaterial"
                            @on-per-page-change="onPerPageChangePackagingMaterial"
                            :totalRows="totalPackagingMaterialRecords"
                            :line-numbers="true"
                            :isLoading.sync="isLoading"
                            :pagination-options="{
                              enabled: true,
                              perPageDropdown: [10, 50, 100, 1000, 10000],
                              dropdownAllowAll: false,
                            }"
                            :rows="rowsPackagingMaterial"
                            :columns="columnsPackagingMaterial"
                          >

                          <div slot="table-actions">
                              {{ $t("no_select_data") }}
                          </div>
                          <div slot="selected-row-actions">
                              <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="PackagingMaterialChangeStatus"> <i
                                  class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>

                              <button class="btn btn-success btn-xs" @click="removePackagingMaterialIds"><i class="mdi mdi-close"></i> {{
                                  $t("unselect_data_txt")
                              }} </button>
                          </div>

                          <template slot="column-filter" slot-scope="{ column }">
                            <span v-if="column.filterOptions.customFilter">

                              <span v-if="column.field =='shipmentDate'">

                                <date-range-picker style="width:100%" @update="shipmentDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="shipmentDateRange" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                  <div slot="header" slot-scope="header" class="slot">
                                    <a @click="clearshipmentDateChange()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                                    <br>
                                  </div>
                                </date-range-picker>

                              </span>
                            
                            </span>
                            

                          </template>


                          </vue-good-table>


                        </div>
                        

                        </div>



                    </div>

                    <div class="card-footer">
                        <button
                            class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                            "
                            @click="backForm"
                            type="button"
                        >
                            <i class="link-icon mdi mdi-arrow-left"></i>
                            {{ $t("backMess") }}
                        </button>
                    
    
                    </div>
                    
                </div>
          </div>
            
          </div>
        </div>
        <!--end::content-->


            <!--begin::footer-->
            <footer-component></footer-component>
            <!--end::footer-->


        <!--begin::modal-->

        <modal name="detailRateClibilling" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                
                <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{this.$t("rate_detail_txt")}}</h5>
                <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
                </div>

                <div class="modal-body">
                    

                <div class="mb-3">
                    <label for="rateName" class="form-label">{{this.$t("rateName_txt")}}:</label>
                    <input type="text" class="form-control" id="rateName" :placeholder="$t('rateName_txt')" v-model="rateHeader.rateName" disabled/>
                </div>

                <div class="mb-3">
                    <label for="warehouseId" class="form-label">{{this.$t("warehouseId_txt")}}:</label>
                    <input type="text" class="form-control" id="warehouseId" :placeholder="$t('warehouseId_txt')" v-model="rateHeader.warehouseId" disabled/>
                </div>

                <div class="mb-3">
                    <label for="customerId" class="form-label">{{this.$t("customerId")}}:</label>
                    <input type="text" class="form-control" id="customerId" :placeholder="$t('customerId')" v-model="rateHeader.customerId" disabled/>
                </div>

                <div class="mb-3">
                    <label for="customerGroup" class="form-label">{{this.$t("customerGroup")}}:</label>
                    <input type="text" class="form-control" id="customerGroup" :placeholder="$t('customerGroup')" v-model="rateHeader.customerGroup" disabled/>
                </div>

                <div class="mb-3">
                    <label for="customerSAPCode" class="form-label">{{this.$t("customerSAPCode")}}:</label>
                    <input type="text" class="form-control" id="customerSAPCode" :placeholder="$t('customerSAPCode')" v-model="rateHeader.customerSAPCode" disabled/>
                </div>

                <div class="mb-3">
                    <label for="firstBilingDate" class="form-label">{{this.$t("firstBilingDate_txt")}}:</label>
                    <input type="text" class="form-control" id="firstBilingDate" :placeholder="$t('firstBilingDate_txt')" v-model="rateHeader.firstBilingDate" disabled/>
                </div>

                <div class="mb-3">
                    <div class="row">

                    <div class="col-sm-6">
                        <label for="effectiveFromDate" class="form-label">{{this.$t("effectiveFromDate")}}:</label>
                        <input type="text" class="form-control" id="effectiveFromDate" :placeholder="$t('effectiveFromDate')" v-model="rateHeader.effectiveFromDate" disabled/>
                    </div>
                    <div class="col-sm-6">
                        <label for="effectiveToDate" class="form-label">{{this.$t("effectiveToDate")}}:</label>
                        <input type="text" class="form-control" id="effectiveToDate" :placeholder="$t('effectiveToDate')" v-model="rateHeader.effectiveToDate" disabled/>
                    </div>

                    </div>
                </div>

                <div class="mb-3">
                    <label for="status" class="form-label">{{this.$t("statusTxt")}}:</label>
                    <input type="text" class="form-control" id="status" :placeholder="$t('statusTxt')" v-model="rateHeader.status" disabled/>
                </div>

                <div class="mb-3">
                    <label for="addwho" class="form-label">{{this.$t("addwho")}}:</label>
                    <input type="text" class="form-control" id="addwho" :placeholder="$t('addwho')" v-model="rateHeader.addwho" disabled/>
                </div>


                <div class="mb-3">
                    <label for="adddate" class="form-label">{{this.$t("adddate")}}:</label>
                    <input type="text" class="form-control" id="adddate" :placeholder="$t('adddate')" v-model="rateHeader.adddate" disabled/>
                </div>


                <div class="mb-3">
                    <label for="editwho" class="form-label">{{this.$t("editwho")}}:</label>
                    <input type="text" class="form-control" id="editwho" :placeholder="$t('editwho')" v-model="rateHeader.editwho" disabled/>
                </div>


                <div class="mb-3">
                    <label for="editdate" class="form-label">{{this.$t("editdate")}}:</label>
                    <input type="text" class="form-control" id="editdate" :placeholder="$t('editdate')" v-model="rateHeader.editdate" disabled/>
                </div>


                <div class="mb-3">
                    <label for="editwho" class="form-label">{{this.$t("detail_rate_detail_txt")}}:</label>
                    <br>


                    <vue-good-table
                        title="list-billing-cli-rate-details"
                        :rows="rateDetails"
                        :columns="columnsRateDetails"
                        :sort-options="{
                            enabled: true,
                        }"
                        :search-options="{
                            enabled: true,
                            trigger: 'enter',
                        }"
                        >
                        <template slot="table-row" slot-scope="props">
                            {{ props.formattedRow[props.column.field] }}
                        </template>
                        </vue-good-table>

                </div>



                </div>

                <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                </div>

              </div>
            </div>
          </div>
        </modal>


        <modal name="uploadVas" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
              <form class="forms-sample" @submit.prevent="submitVas" method="POST">
                <div class="modal-header">
                  <h5 class="modal-title" id="uploadVas">{{this.$t("upload_vas")}}</h5>
                  <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
                </div>
    
                <div class="modal-body">
                    
    
                  <div class="mb-3">
                    <label for="files" class="form-label">{{this.$t("file")}}:</label>
                    <input type="file" class="form-control" ref="fileVas" @change="handleFileUploadVas($event)"  required/>
                      
                    <div v-if="errors.file">
                      <div
                        v-for="error in errors.file"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                      </div>
                    </div>
    
                  </div>
    
                  <div class="mb-3">
                    <br>
                    <label for="download_template_vas" class="form-label"><a @click="downloadVasTemplate()" style="color: #6571ff;text-decoration: none;">{{this.$t("download_template_vas")}}</a></label>
                  </div>
    
    
                  <div class="mb-3" v-if="errorsVasUpload">
    
                    <div class="table-responsive">
                      <table class="table table-hover">
    
                        <thead>
                          <th>{{$t('docNo')}}</th>
                          <th>{{$t('statusTxt')}}</th>
                        </thead>
                        <tbody>
                          <tr v-for="(errorVas, index) in errorsVasUpload" :key="index">
                            <th>{{errorVas.docNo}}</th>
                            <th>{{errorVas.status}}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                  </div>
            
    
                </div>
    
                <div class="modal-footer justify-content-between">
                  <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                  <button type="submit" class="btn btn-primary">{{ this.$t("UploadTxt") }}</button>
                </div>
              </form>
              </div>
            </div>
          </div>
        </modal>


        <modal name="uploadOvertime" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
          <form class="forms-sample" @submit.prevent="submitOvertime" method="POST">
            <div class="modal-header">
              <h5 class="modal-title" id="uploadOvertime">{{this.$t("upload_overtime")}}</h5>
              <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
            </div>

            <div class="modal-body">
                

              <div class="mb-3">
                <label for="files" class="form-label">{{this.$t("file")}}:</label>
                <input type="file" class="form-control" ref="fileOvertime" @change="handleFileUploadOvertime($event)"  required/>
                  
                <div v-if="errors.file">
                  <div
                    v-for="error in errors.file"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>

              </div>

              <div class="mb-3">
                <br>
                <label for="download_template_vas" class="form-label"><a @click="downloadOvertimeTemplate()" style="color: #6571ff;text-decoration: none;">{{this.$t("download_template_overtime")}}</a></label>
              </div>


              <div class="mb-3" v-if="errorsOvertimeUpload">


                <div class="table-responsive">
                  <table class="table table-hover">

                    <thead>
                      <th>{{$t('docNo')}}</th>
                      <th>{{$t('statusTxt')}}</th>
                    </thead>
                    <tbody>
                      <tr v-for="(errorOvertime, index) in errorsOvertimeUpload" :key="index">
                        <th>{{errorOvertime.nik}}</th>
                        <th>{{errorOvertime.status}}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                

              </div>


            </div>

            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
              <button type="submit" class="btn btn-primary">{{ this.$t("UploadTxt") }}</button>
            </div>
          </form>
              </div>
            </div>
          </div>
        </modal>

        <!--end::modal-->

        </div>
    </div>
  </div>
</template>



<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';

export default {

    name: "CliBillingSubDetail",
    props: {},
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
      DateRangePicker,
    },
  data() {
    return {
      opens:"center",
      locale:{
        format:"yyyy-mm-dd",
      
      },
      highlighted:{

          dates: [ // Highlight an array of dates
            new Date(),
          ],

      },
      chargeCategory:"",
      chargeType:"",
      idBillingHeader:"",
      idBillingDetail:"",
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      amountData:0,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      companyName:"",
      amountCategory:0,
      billingDetail: { idbillingDetail:"", idBillingHeader: "",chargeCategory:"" , chargeType:"", amountCategory:0, addwho:"",  editwho:"", adddate:"",  editdate:""},
      rateHeader: { bm_rate_detail: [],effectiveDate:"", idRateHeader: "",rateName:"" , warehouseId:"", customerId:"", customerGroup:"", customerSAPCode:"", firstBilingDate:"", effectiveFromDate:"", effectiveToDate:"", status:"", addwho:"",  editwho:""},
      forms: { bt_billing_detail: [],transactionDate:"", idRateHeader: "",idBillingHeader:"" , warehouseId:"", customerId:"", customerGroup:"", customerSAPCode:"", transactionFromDate:"", transactionToDate:"", status:"", addwho:"",  editwho:"",amount:0},
      columns: [
        {
          label: this.$t("chargeCategory_txt"),
          field: "chargeCategory",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeCategory_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("chargeType_txt"),
          field: "chargeType",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeType_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("amount_txt"),
          field: "amountCategory",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("amount_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

          {
            label: this.$t("action_txt"),
            field: "actions",
            sortable: false,
            filterOptions: {
              customFilter: false,
              enabled: false, 
            },
          },
      ],
      columnsRateDetails: [
        {
          label: this.$t("chargeCategory_txt"),
          field: "chargeCategory",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeCategory_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("chargeType_txt"),
          field: "chargeType",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeType_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("rateBase_txt"),
          field: "rateBase",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("rateBase_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("SAPMaterialCode"),
          field: "SAPMaterialCode",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("SAPMaterialCode_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("SAPDivision"),
          field: "SAPDivision",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("SAPDivision_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("tier"),
          field: "tier",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("tier_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("tierQty"),
          field: "tierQty",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("tierQty_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
   
        {
          label: this.$t("ratePerUnit"),
          field: "ratePerUnit",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("ratePerUnit_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("remarks_txt"),
          field: "remark",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("remark_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rows: [],
      rateDetails:[],
      rowsSelectionVas:[],
      idCodeLkupsVas:[],
      serverVasParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      totalVasRecords:0,
      rowsVas: [],
      receiveDateVasFrom:"",
      receiveDateVasTo:"",
      receiveDateVasRange: {
        startDate: null,
        endDate: null
      },
      columnsVas: [
        {
          label: this.$t("vasType"),
          field: "vasType",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("vasType"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docNo"),
          field: "docNo",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docNo_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docLineNo"),
          field: "docLineNo",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docLineNo"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("receiveDate"),
          field: "receiveDate",
          filterOptions: {
            customFilter: true,
            enabled: true, // enable filter for this column
            placeholder: this.$t("receiveDate"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docType"),
          field: "docType",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docType"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuCodeTxt"),
          field: "sku",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("skuCodeTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_txt"),
          field: "qty",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("uom"),
          field: "uom",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("uom"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("rate_txt"),
          field: "rate",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("rate_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("amount_txt"),
          field: "amount",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("amount_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['BILL','NOT BILL'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rowsSelectionOvertime:[],
      idCodeLkupsOvertime:[],
      serverOvertimeParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      totalOvertimeRecords:0,
      rowsOvertime: [],
      startOvertimeFrom:"",
      startOvertimeTo:"",
      startOvertimeRange: {
        startDate: null,
        endDate: null
      },
      endOvertimeFrom:"",
      endOvertimeTo:"",
      endOvertimeRange: {
        startDate: null,
        endDate: null
      },
      columnsOvertime: [
        {
          label: this.$t("nik"),
          field: "nik",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("nik"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("name"),
          field: "name",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("name"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("categoryCode_txt"),
          field: "categoryCode",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("categoryCode_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("startOvertime"),
          field: "startOvertime",
          filterOptions: {
            customFilter: true,
            enabled: true, // enable filter for this column
            placeholder: this.$t("startOvertime"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("endOvertime"),
          field: "endOvertime",
          filterOptions: {
            customFilter: true,
            enabled: true, // enable filter for this column
            placeholder: this.$t("endOvertime"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("breakTime"),
          field: "breakTime",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("breakTime"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("totalOvertime"),
          field: "totalOvertime",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("totalOvertime"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("rate_txt"),
          field: "rate",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("rate_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("amount_txt"),
          field: "totalAmount",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("amount_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['BILL','NOT BILL'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rowsSelectionFixCharge:[],
      idCodeLkupsFixCharge:[],
      serverFixChargeParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      totalFixChargeRecords:0,
      rowsFixCharge: [],
      columnsFixCharge: [
        {
          label: this.$t("amount_txt"),
          field: "amount",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("amount_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['BILL','NOT BILL'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rowsSelectionStorage:[],
      idCodeLkupsStorage:[],
      serverStorageParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      totalStorageRecords:0,
      rowsStorage: [],
      stockDateFrom:"",
      stockDateTo:"",
      stockDateRange: {
        startDate: null,
        endDate: null
      },
      columnsStorage: [
        {
          label: this.$t("customerId_txt"),
          field: "customerId",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("customerId_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuCodeTxt"),
          field: "sku",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("skuCodeTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuDescriptionTxt"),
          field: "skuDescription",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("skuDescriptionTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuGroup"),
          field: "skuGroup",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("skuGroup"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("stockDate"),
          field: "stockDate",
          filterOptions: {
            customFilter: true,
            enabled: true, // enable filter for this column
            placeholder: this.$t("stockDate"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("locationCategory"),
          field: "locationCategory",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("locationCategory"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("storageType"),
          field: "storageType",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("storageType"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("cbm"),
          field: "cbm",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("cbm"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_txt"),
          field: "qty",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("uom"),
          field: "UOM",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("uom"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("rate_txt"),
          field: "rate",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("rate_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("amount_txt"),
          field: "amount",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("amount_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['BILL','NOT BILL'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rowsSelectionHandlingIn:[],
      idCodeLkupsHandlingIn:[],
      serverHandlingInParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      totalHandlingInRecords:0,
      rowsHandlingIn: [],
      receiveDateFrom:"",
      receiveDateTo:"",
      receiveDateRange: {
        startDate: null,
        endDate: null
      },
      columnsHandlingIn: [
        {
          label: this.$t("customerId_txt"),
          field: "customerId",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("customerId_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docNo"),
          field: "docNo",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docNo"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docLineNo"),
          field: "docLineNo",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docLineNo"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("asnReference1"),
          field: "asnReference1",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("asnReference1"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("receiveDate"),
          field: "receiveDate",
          filterOptions: {
            customFilter: true,
            enabled: true, // enable filter for this column
            placeholder: this.$t("receiveDate"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docType"),
          field: "docType",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docType"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("sku_txt"),
          field: "sku",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("sku_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuDescriptionTxt"),
          field: "skuDescription",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("skuDescriptionTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_each"),
          field: "qtyEach",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_each"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_cases"),
          field: "qtyCases",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_cases"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_charge"),
          field: "qty",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_charge"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("rate_txt"),
          field: "rate",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("rate_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("uom"),
          field: "uom",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("uom"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("amount_txt"),
          field: "amount",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("amount_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['BILL','NOT BILL'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rowsSelectionHandlingOut:[],
      idCodeLkupsHandlingOut:[],
      serverHandlingOutParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      totalHandlingOutRecords:0,
      rowsHandlingOut: [],
      shipmentDateFrom:"",
      shipmentDateTo:"",
      shipmentDateRange: {
        startDate: null,
        endDate: null
      },
      columnsHandlingOut: [
        {
          label: this.$t("statusTxt"),
          field: "status",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['BILL','NOT BILL'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("customerId_txt"),
          field: "customerId",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("customerId_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docNo"),
          field: "docNo",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docNo"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docLineNo"),
          field: "docLineNo",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docLineNo"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("omsNumber"),
          field: "omsNumber",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("omsNumber"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("airwayBill"),
          field: "airwayBill",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("airwayBill"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("shipmentDate"),
          field: "shipmentDate",
          filterOptions: {
            customFilter: true,
            enabled: true, // enable filter for this column
            placeholder: this.$t("shipmentDate"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docType"),
          field: "docType",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docType"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("sku_txt"),
          field: "sku",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("sku_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuDescriptionTxt"),
          field: "skuDescription",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("skuDescriptionTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_each"),
          field: "qtyShippedEach",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_each"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_cases"),
          field: "qtyCases",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_cases"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_charge"),
          field: "qty",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_charge"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("uom"),
          field: "uom",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("uom"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("omsNumber"),
          field: "omsNumber",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("omsNumber"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("airwayBill"),
          field: "airwayBill",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("airwayBill"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("rate_txt"),
          field: "rate",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("rate_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("amount_txt"),
          field: "amount",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("amount_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rowsSelectionMinimumCharge:[],
      idCodeLkupsMinimumCharge:[],
      serverMinimumChargeParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      totalMinimumChargeRecords:0,
      rowsMinimumCharge: [],
      columnsMinimumCharge: [
        {
          label: this.$t("amount_txt"),
          field: "minimumChargeAmount",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("amount_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      formsVas: { idBillingHeader:"", idBillingDetail:"" , file_vas:"",chargeType:""},
      fileVas: '',
      errorsVasUpload:false,
      errorsOvertimeUpload:false,
      fileOvertime: '',
      formsOvertime: { idBillingHeader:"", idBillingDetail:"" , file_overtime:""},

      rowsSelectionPackagingMaterial:[],
      idCodeLkupsPackagingMaterial:[],
      serverPackagingMaterialParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      totalPackagingMaterialRecords:0,
      rowsPackagingMaterial: [],
      columnsPackagingMaterial: [
        {
          label: this.$t("customerId_txt"),
          field: "customerId",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("customerId_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docNo"),
          field: "docNo",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docNo"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docLineNo"),
          field: "docLineNo",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docLineNo"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("omsNumber"),
          field: "omsNumber",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("omsNumber"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("airwayBill"),
          field: "airwayBill",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("airwayBill"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("shipmentDate"),
          field: "shipmentDate",
          filterOptions: {
            customFilter: true,
            enabled: true, // enable filter for this column
            placeholder: this.$t("shipmentDate"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("docType"),
          field: "docType",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("docType"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("sku_txt"),
          field: "sku",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("sku_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuDescriptionTxt"),
          field: "skuDescription",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("skuDescriptionTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_each"),
          field: "qtyShippedEach",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_each"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_cases"),
          field: "qtyCases",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_cases"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_charge"),
          field: "qty",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qty_charge"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("uom"),
          field: "uom",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("uom"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("rate_txt"),
          field: "rate",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("rate_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("amount_txt"),
          field: "amount",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("amount_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          filterOptions: {
            customFilter: false,
            enabled: true, // enable filter for this column
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['BILL','NOT BILL'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
    };
  },
  watch: {},
  methods: {

    resetForm(){
      this.fileVas                    = ""
      this.fileOvertime               = ""
    },

    handleFileUploadOvertime( event ){
      this.fileOvertime = event.target.files[0];
    },

    submitOvertime() {
      this.isLoading = true;
        
      let formData = new FormData();
      formData.append("file", this.fileOvertime);
      formData.append("idBillingDetail", this.idBillingDetail);
      formData.append("idBillingHeader", this.idBillingHeader);
      formData.append("categoryCode", this.chargeType);
      
      const baseURI  =  this.$settings.endPointBilling+"dashboard/cli-billing/bt-billing-detail-overtime-charge-upload";

      this.$http.post(baseURI,formData).then((response) => {
      this.isLoading = false;
      this.errorsOvertimeUpload = response.data.datas;
      this.resetForm();
      this.loadData();
      this.loadDataDetail();
      this.loadDataSubDetail();
    }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
    },
  

    downloadOvertimeTemplate(){
  
      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-overtime-charge-download-template-xlsx";
      var file_name   = "overtime-data-templates.xlsx";


      return this.$http
      .get(
        baseURI,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },


    uploadOvertime(){
      this.$modal.show('uploadOvertime')
    },


    submitVas() {
      this.isLoading = true;
        
      let formData = new FormData();
      formData.append("file", this.fileVas);
      formData.append("idBillingDetail", this.idBillingDetail);
      formData.append("idBillingHeader", this.idBillingHeader);
      formData.append("chargeType", this.chargeType);
      
      const baseURI  =  this.$settings.endPointBilling+"dashboard/cli-billing/bt-billing-detail-vas-charge-upload";

      this.$http.post(baseURI,formData).then((response) => {
      this.isLoading = false;
      this.errorsVasUpload = response.data.datas;
      this.resetForm();
      this.loadData();
      this.loadDataDetail();
      this.loadDataSubDetail();
    }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
      
    },

    downloadVasTemplate(){
  
      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-vas-charge-download-template-xlsx";
      var file_name   = "vas-data-templates.xlsx";


      return this.$http
      .get(
        baseURI,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },

    handleFileUploadVas( event ){
      this.fileVas = event.target.files[0];
    },

    uploadVas() {
      this.$modal.show('uploadVas')
    },

    downloadDataMinimumCharge() {
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-minimum-charge/"+idBillingDetail;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name   = "download_" + CurrentDate + ".xlsx";


      return this.$http
      .get(
        baseURI +
          `?limit=${this.serverMinimumChargeParams.per_page}&page=${this.serverMinimumChargeParams.page}&sort_field=${this.serverMinimumChargeParams.sort.field}&sort_type=${this.serverMinimumChargeParams.sort.type}&download=download`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },

    MinimumChargeChangeStatus(){
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: 'NOT BILL',
      }).then((result) => {
        if (result.value) {
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailMinimumCharges: this.idCodeLkupsMinimumCharge,
            status: "BILL",
          }

 
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-minimum-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }else{
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailMinimumCharges: this.idCodeLkupsMinimumCharge,
            status: "NOT BILL",
          }

          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-minimum-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
             
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
        }
      });

    },

    removeMinimumChargeIds() {
      this.idCodeLkupsMinimumCharge = [];
      this.$refs['list-billing-detail-MinimumCharge'].unselectAllInternal()
    },

    onPerPageChangeMinimumCharge(params) {
      this.updateMinimumChargeParams({ per_page: params.currentPerPage });
    },

    onColumnFilterMinimumCharge(params) {
      this.updateMinimumChargeParams(params);
    },

    onSortChangeMinimumCharge(params) {
      this.updateMinimumChargeParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },
  
    updateMinimumChargeParams(newProps) {
      this.serverMinimumChargeParams = Object.assign({}, this.serverMinimumChargeParams, newProps);
      this.loadMinimumChargeItems();
    },

    onPageChangeMinimumCharge(params) {
      this.updateMinimumChargeParams({ page: params.currentPage });
    },

    selectionChangedMinimumCharge(ev) {
      this.rowsSelectionMinimumCharge = [];
      this.idCodeLkupsMinimumCharge   = [];
      this.rowsSelectionMinimumCharge = ev.selectedRows;

      this.rowsSelectionMinimumCharge.forEach((item) => {
        this.idCodeLkupsMinimumCharge.push(item.idDetailMinimumCharge);

      });

    },
  

    loadMinimumChargeItems(){
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-minimum-charge/"+idBillingDetail;
      this.isLoading = true;
      return this.$http
      .get(
          baseURI +
          `?limit=${this.serverMinimumChargeParams.per_page}&page=${this.serverMinimumChargeParams.page}&sort_field=${this.serverMinimumChargeParams.sort.field}&sort_type=${this.serverMinimumChargeParams.sort.type}`,
        { timeout: 10000 })
      .then((response) => {
        this.isLoading            = false;
        this.rowsMinimumCharge         = response.data.datas.data;
        this.totalMinimumChargeRecords = response.data.datas.total;
      }).catch((error) => {
          this.loading();
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
    },

    downloadDataPackagingMaterial() {
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-out-charge/"+idBillingDetail;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name   = "download_" + CurrentDate + ".xlsx";


      return this.$http
      .get(
        baseURI +
          `?limit=${this.serverPackagingMaterialParams.per_page}&page=${this.serverPackagingMaterialParams.page}&sort_field=${this.serverPackagingMaterialParams.sort.field}&sort_type=${this.serverPackagingMaterialParams.sort.type}&docNo=${this.serverPackagingMaterialParams.columnFilters.docNo}&docLineNo=${this.serverPackagingMaterialParams.columnFilters.docLineNo}&docType=${this.serverPackagingMaterialParams.columnFilters.docType}&sku=${this.serverPackagingMaterialParams.columnFilters.sku}&uom=${this.serverPackagingMaterialParams.columnFilters.uom}&status=${this.serverPackagingMaterialParams.columnFilters.status}&shipmentDateFrom=${this.shipmentDateFrom}&shipmentDateTo=${this.shipmentDateTo}&skuDescription=${this.serverPackagingMaterialParams.columnFilters.skuDescription}&omsNumber=${this.serverPackagingMaterialParams.columnFilters.omsNumber}&airwayBill=${this.serverPackagingMaterialParams.columnFilters.airwayBill}&download=download`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },

    PackagingMaterialChangeStatus(){
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: 'NOT BILL',
      }).then((result) => {
        if (result.value) {
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailHandlingOuts: this.idCodeLkupsPackagingMaterial,
            status: "BILL",
          }

    
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-out-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }else{
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailHandlingOuts: this.idCodeLkupsPackagingMaterial,
            status: "NOT BILL",
          }

          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-out-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
        }
      });

    },

    removePackagingMaterialIds() {
      this.idCodeLkupsPackagingMaterial = [];
      this.$refs['list-billing-detail-PackagingMaterial'].unselectAllInternal()
    },

    onPerPageChangePackagingMaterial(params) {
      this.updatePackagingMaterialParams({ per_page: params.currentPerPage });
    },

    onColumnFilterPackagingMaterial(params) {
      this.updatePackagingMaterialParams(params);
    },

    onSortChangePackagingMaterial(params) {
      this.updatePackagingMaterialParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    updatePackagingMaterialParams(newProps) {
      this.serverPackagingMaterialParams = Object.assign({}, this.serverPackagingMaterialParams, newProps);
      this.loadPackagingMaterialItems();
    },

    onPageChangePackagingMaterial(params) {
      this.updatePackagingMaterialParams({ page: params.currentPage });
    },

    selectionChangedPackagingMaterial(ev) {
      this.rowsSelectionPackagingMaterial = [];
      this.idCodeLkupsPackagingMaterial   = [];
      this.rowsSelectionPackagingMaterial = ev.selectedRows;

      this.rowsSelectionPackagingMaterial.forEach((item) => {
        this.idCodeLkupsPackagingMaterial.push(item.idDetailHandlingOut);

      });

    },

    loadPackagingMaterialItems(){
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-out-charge/"+idBillingDetail;
      this.isLoading = true;
      return this.$http
      .get(
          baseURI +
          `?limit=${this.serverPackagingMaterialParams.per_page}&page=${this.serverPackagingMaterialParams.page}&sort_field=${this.serverPackagingMaterialParams.sort.field}&sort_type=${this.serverPackagingMaterialParams.sort.type}&docNo=${this.serverPackagingMaterialParams.columnFilters.docNo}&docLineNo=${this.serverPackagingMaterialParams.columnFilters.docLineNo}&docType=${this.serverPackagingMaterialParams.columnFilters.docType}&sku=${this.serverPackagingMaterialParams.columnFilters.sku}&uom=${this.serverPackagingMaterialParams.columnFilters.uom}&status=${this.serverPackagingMaterialParams.columnFilters.status}&shipmentDateFrom=${this.shipmentDateFrom}&shipmentDateTo=${this.shipmentDateTo}&skuDescription=${this.serverPackagingMaterialParams.columnFilters.skuDescription}&omsNumber=${this.serverPackagingMaterialParams.columnFilters.omsNumber}&airwayBill=${this.serverPackagingMaterialParams.columnFilters.airwayBill}`,
        { timeout: 10000 })
      .then((response) => {
        this.isLoading            = false;
        this.rowsPackagingMaterial         = response.data.datas.data;
        this.totalPackagingMaterialRecords = response.data.datas.total;
      }).catch((error) => {
          this.loading();
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
    },



    downloadDataHandlingOut() {
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-out-charge/"+idBillingDetail;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name   = "download_" + CurrentDate + ".xlsx";


      return this.$http
      .get(
        baseURI +
          `?limit=${this.serverHandlingOutParams.per_page}&page=${this.serverHandlingOutParams.page}&sort_field=${this.serverHandlingOutParams.sort.field}&sort_type=${this.serverHandlingOutParams.sort.type}&docNo=${this.serverHandlingOutParams.columnFilters.docNo}&docLineNo=${this.serverHandlingOutParams.columnFilters.docLineNo}&docType=${this.serverHandlingOutParams.columnFilters.docType}&sku=${this.serverHandlingOutParams.columnFilters.sku}&uom=${this.serverHandlingOutParams.columnFilters.uom}&airwayBill=${this.serverHandlingOutParams.columnFilters.airwayBill}&omsNumber=${this.serverHandlingOutParams.columnFilters.omsNumber}&status=${this.serverHandlingOutParams.columnFilters.status}&shipmentDateFrom=${this.shipmentDateFrom}&shipmentDateTo=${this.shipmentDateTo}&skuDescription=${this.serverHandlingOutParams.columnFilters.skuDescription}&omsNumber=${this.serverHandlingOutParams.columnFilters.omsNumber}&airwayBill=${this.serverHandlingOutParams.columnFilters.airwayBill}&download=download`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },
  
    HandlingOutChangeStatus(){
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: 'NOT BILL',
      }).then((result) => {
        if (result.value) {
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailHandlingOuts: this.idCodeLkupsHandlingOut,
            status: "BILL",
          }

    
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-out-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }else{
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailHandlingOuts: this.idCodeLkupsHandlingOut,
            status: "NOT BILL",
          }

          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-out-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
        }
      });

    },
    
    removeHandlingOutIds() {
      this.idCodeLkupsHandlingOut = [];
      this.$refs['list-billing-detail-HandlingOut'].unselectAllInternal()
    },

    onPerPageChangeHandlingOut(params) {
      this.updateHandlingOutParams({ per_page: params.currentPerPage });
    },

    onColumnFilterHandlingOut(params) {
      this.updateHandlingOutParams(params);
    },

    onSortChangeHandlingOut(params) {
      this.updateHandlingOutParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    updateHandlingOutParams(newProps) {
      this.serverHandlingOutParams = Object.assign({}, this.serverHandlingOutParams, newProps);
      this.loadHandlingOutItems();
    },

    onPageChangeHandlingOut(params) {
      this.updateHandlingOutParams({ page: params.currentPage });
    },

    selectionChangedHandlingOut(ev) {
      this.rowsSelectionHandlingOut = [];
      this.idCodeLkupsHandlingOut   = [];
      this.rowsSelectionHandlingOut = ev.selectedRows;

      this.rowsSelectionHandlingOut.forEach((item) => {
        this.idCodeLkupsHandlingOut.push(item.idDetailHandlingOut);

      });

    },
  
    loadHandlingOutItems(){
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-out-charge/"+idBillingDetail;
      this.isLoading = true;
      return this.$http
      .get(
          baseURI +
          `?limit=${this.serverHandlingOutParams.per_page}&page=${this.serverHandlingOutParams.page}&sort_field=${this.serverHandlingOutParams.sort.field}&sort_type=${this.serverHandlingOutParams.sort.type}&docNo=${this.serverHandlingOutParams.columnFilters.docNo}&docLineNo=${this.serverHandlingOutParams.columnFilters.docLineNo}&docType=${this.serverHandlingOutParams.columnFilters.docType}&sku=${this.serverHandlingOutParams.columnFilters.sku}&uom=${this.serverHandlingOutParams.columnFilters.uom}&airwayBill=${this.serverHandlingOutParams.columnFilters.airwayBill}&omsNumber=${this.serverHandlingOutParams.columnFilters.omsNumber}&status=${this.serverHandlingOutParams.columnFilters.status}&shipmentDateFrom=${this.shipmentDateFrom}&shipmentDateTo=${this.shipmentDateTo}&skuDescription=${this.serverHandlingOutParams.columnFilters.skuDescription}&omsNumber=${this.serverHandlingOutParams.columnFilters.omsNumber}&airwayBill=${this.serverHandlingOutParams.columnFilters.airwayBill}`,
        { timeout: 10000 })
      .then((response) => {
        this.isLoading            = false;
        this.rowsHandlingOut         = response.data.datas.data;
        this.totalHandlingOutRecords = response.data.datas.total;
      }).catch((error) => {
          this.loading();
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
    },

    shipmentDateChange(){

      if(this.shipmentDateRange.startDate && this.shipmentDateRange.endDate){
        this.shipmentDateFrom=this.$moment(String(this.shipmentDateRange.startDate)).format('YYYY-MM-DD');
        this.shipmentDateTo=this.$moment(String(this.shipmentDateRange.endDate)).format('YYYY-MM-DD');
        this.loadHandlingOutItems()
      }

    },
  
  
    clearshipmentDateChange(){
      this.shipmentDateRange={
        startDate: null,
        endDate: null
      };
      this.shipmentDateFrom = ""
      this.shipmentDateTo = ""
      this.loadHandlingOutItems()
    },

    downloadDataHandlingIn() {
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-in-charge/"+idBillingDetail;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name   = "download_" + CurrentDate + ".xlsx";


      return this.$http
      .get(
        baseURI +
          `?limit=${this.serverHandlingInParams.per_page}&page=${this.serverHandlingInParams.page}&sort_field=${this.serverHandlingInParams.sort.field}&sort_type=${this.serverHandlingInParams.sort.type}&docNo=${this.serverHandlingInParams.columnFilters.docNo}&uom=${this.serverHandlingInParams.columnFilters.uom}&docLineNo=${this.serverHandlingInParams.columnFilters.docLineNo}&docType=${this.serverHandlingInParams.columnFilters.docType}&sku=${this.serverHandlingInParams.columnFilters.sku}&status=${this.serverHandlingInParams.columnFilters.status}&asnReference1=${this.serverHandlingInParams.columnFilters.asnReference1}&receiveDateFrom=${this.receiveDateFrom}&receiveDateTo=${this.receiveDateTo}&skuDescription=${this.serverHandlingInParams.columnFilters.skuDescription}&download=download`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },

    HandlingInChangeStatus(){
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: 'NOT BILL',
      }).then((result) => {
        if (result.value) {
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailHandlingIns: this.idCodeLkupsHandlingIn,
            status: "BILL",
          }

          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-in-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }else{
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailHandlingIns: this.idCodeLkupsHandlingIn,
            status: "NOT BILL",
          }
          

          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-in-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });


        }
      });

    },
  
    removeHandlingInIds() {
      this.idCodeLkupsHandlingIn = [];
      this.$refs['list-billing-detail-HandlingIn'].unselectAllInternal()
    },

    onPerPageChangeHandlingIn(params) {
      this.updateHandlingInParams({ per_page: params.currentPerPage });
    },

    onColumnFilterHandlingIn(params) {
      this.updateHandlingInParams(params);
    },

    onSortChangeHandlingIn(params) {
      this.updateHandlingInParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    updateHandlingInParams(newProps) {
      this.serverHandlingInParams = Object.assign({}, this.serverHandlingInParams, newProps);
      this.loadHandlingInItems();
    },

    onPageChangeHandlingIn(params) {
      this.updateHandlingInParams({ page: params.currentPage });
    },

    selectionChangedHandlingIn(ev) {
      this.rowsSelectionHandlingIn = [];
      this.idCodeLkupsHandlingIn   = [];
      this.rowsSelectionHandlingIn = ev.selectedRows;

      this.rowsSelectionHandlingIn.forEach((item) => {
        this.idCodeLkupsHandlingIn.push(item.idDetailHandlingIn);

      });

    },

    loadHandlingInItems(){
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-handling-in-charge/"+idBillingDetail;
      this.isLoading = true;
      return this.$http
      .get(
          baseURI +
          `?limit=${this.serverHandlingInParams.per_page}&page=${this.serverHandlingInParams.page}&sort_field=${this.serverHandlingInParams.sort.field}&sort_type=${this.serverHandlingInParams.sort.type}&docNo=${this.serverHandlingInParams.columnFilters.docNo}&docLineNo=${this.serverHandlingInParams.columnFilters.docLineNo}&docType=${this.serverHandlingInParams.columnFilters.docType}&sku=${this.serverHandlingInParams.columnFilters.sku}&uom=${this.serverHandlingInParams.columnFilters.uom}&status=${this.serverHandlingInParams.columnFilters.status}&asnReference1=${this.serverHandlingInParams.columnFilters.asnReference1}&receiveDateFrom=${this.receiveDateFrom}&receiveDateTo=${this.receiveDateTo}&skuDescription=${this.serverHandlingInParams.columnFilters.skuDescription}`,
        { timeout: 10000 })
      .then((response) => {
        this.isLoading            = false;
        this.rowsHandlingIn         = response.data.datas.data;
        this.totalHandlingInRecords = response.data.datas.total;
      }).catch((error) => {
          this.loading();
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
    },

    receiveDateChange(){

      if(this.receiveDateRange.startDate && this.receiveDateRange.endDate){
        this.receiveDateFrom=this.$moment(String(this.receiveDateRange.startDate)).format('YYYY-MM-DD');
        this.receiveDateTo=this.$moment(String(this.receiveDateRange.endDate)).format('YYYY-MM-DD');
        this.loadHandlingInItems()
      }

    },
  
  
    clearreceiveDateChange(){
      this.receiveDateRange={
        startDate: null,
        endDate: null
      };
      this.receiveDateFrom = ""
      this.receiveDateTo = ""
      this.loadHandlingInItems()
    },

    downloadDataStorage() {
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-storage-charge/"+idBillingDetail;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name   = "download_" + CurrentDate + ".xlsx";


      return this.$http
      .get(
        baseURI +
          `?limit=${this.serverStorageParams.per_page}&page=${this.serverStorageParams.page}&sort_field=${this.serverStorageParams.sort.field}&sort_type=${this.serverStorageParams.sort.type}&locationCategory=${this.serverStorageParams.columnFilters.locationCategory}&UOM=${this.serverStorageParams.columnFilters.UOM}&status=${this.serverStorageParams.columnFilters.status}&skuGroup=${this.serverStorageParams.columnFilters.skuGroup}&sku=${this.serverStorageParams.columnFilters.sku}&skuDescription=${this.serverStorageParams.columnFilters.skuDescription}&storageType=${this.serverStorageParams.columnFilters.storageType}&download=download`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },

    StorageChangeStatus(){
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: 'NOT BILL',
      }).then((result) => {
        if (result.value) {
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailStorages: this.idCodeLkupsStorage,
            status: "BILL",
          }

    
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-storage-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }else{
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailStorages: this.idCodeLkupsStorage,
            status: "NOT BILL",
          }
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-storage-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }
      });

    },
  

    removeStorageIds() {
      this.idCodeLkupsStorage = [];
      this.$refs['list-billing-detail-Storage'].unselectAllInternal()
    },

    onPerPageChangeStorage(params) {
      this.updateStorageParams({ per_page: params.currentPerPage });
    },

    onColumnFilterStorage(params) {
      this.updateStorageParams(params);
    },

    onSortChangeStorage(params) {
      this.updateStorageParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },
  
    updateStorageParams(newProps) {
      this.serverStorageParams = Object.assign({}, this.serverStorageParams, newProps);
      this.loadStorageItems();
    },

    onPageChangeStorage(params) {
      this.updateStorageParams({ page: params.currentPage });
    },
  
    selectionChangedStorage(ev) {
      this.rowsSelectionStorage = [];
      this.idCodeLkupsStorage   = [];
      this.rowsSelectionStorage = ev.selectedRows;

      this.rowsSelectionStorage.forEach((item) => {
        this.idCodeLkupsStorage.push(item.idDetailStorage);

      });

    },

    loadStorageItems(){
        var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
        let idBillingDetail  = idBillingDetails[0];
  
        const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-storage-charge/"+idBillingDetail;
        this.isLoading = true;
        return this.$http
        .get(
            baseURI +
            `?limit=${this.serverStorageParams.per_page}&page=${this.serverStorageParams.page}&sort_field=${this.serverStorageParams.sort.field}&sort_type=${this.serverStorageParams.sort.type}&locationCategory=${this.serverStorageParams.columnFilters.locationCategory}&UOM=${this.serverStorageParams.columnFilters.UOM}&status=${this.serverStorageParams.columnFilters.status}&skuGroup=${this.serverStorageParams.columnFilters.skuGroup}&sku=${this.serverStorageParams.columnFilters.sku}&stockDateFrom=${this.stockDateFrom}&stockDateTo=${this.stockDateTo}&skuDescription=${this.serverStorageParams.columnFilters.skuDescription}&storageType=${this.serverStorageParams.columnFilters.storageType}`,
          { timeout: 10000 })
        .then((response) => {
          this.isLoading            = false;
          this.rowsStorage         = response.data.datas.data;
          this.totalStorageRecords = response.data.datas.total;
        }).catch((error) => {
            this.loading();
            
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
        });
    },


    stockDateChange(){

      if(this.stockDateRange.startDate && this.stockDateRange.endDate){
        this.stockDateFrom=this.$moment(String(this.stockDateRange.startDate)).format('YYYY-MM-DD');
        this.stockDateTo=this.$moment(String(this.stockDateRange.endDate)).format('YYYY-MM-DD');
        this.loadStorageItems()
      }

    },


    clearstockDateChange(){
      this.stockDateRange={
        startDate: null,
        endDate: null
      };
      this.stockDateFrom = ""
      this.stockDateTo = ""
      this.loadStorageItems()
    },

    downloadDataFixCharge() {
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-fixed-charge/"+idBillingDetail;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name   = "download_" + CurrentDate + ".xlsx";


      return this.$http
      .get(
        baseURI +
          `?limit=${this.serverFixChargeParams.per_page}&page=${this.serverFixChargeParams.page}&sort_field=${this.serverFixChargeParams.sort.field}&sort_type=${this.serverFixChargeParams.sort.type}&status=${this.serverFixChargeParams.columnFilters.status}&download=download`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },
  
    FixChargeChangeStatus(){
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: 'NOT BILL',
      }).then((result) => {
        if (result.value) {
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailFixCharges: this.idCodeLkupsFixCharge,
            status: "BILL",
          }

          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-fix-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
             
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }else{
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailFixCharges: this.idCodeLkupsFixCharge,
            status: "NOT BILL",
          }

          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-fix-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }
      });

    },
  
    removeFixChargeIds() {
      this.idCodeLkupsFixCharge = [];
      this.$refs['list-billing-detail-FixCharge'].unselectAllInternal()
    },
  
    onPerPageChangeFixCharge(params) {
      this.updateFixChargeParams({ per_page: params.currentPerPage });
    },

    onColumnFilterFixCharge(params) {
      this.updateFixChargeParams(params);
    },

    onSortChangeFixCharge(params) {
      this.updateFixChargeParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },
  
    updateFixChargeParams(newProps) {
      this.serverFixChargeParams = Object.assign({}, this.serverFixChargeParams, newProps);
      this.loadFixChargeItems();
    },

    onPageChangeFixCharge(params) {
      this.updateFixChargeParams({ page: params.currentPage });
    },
  
    selectionChangedFixCharge(ev) {
      this.rowsSelectionFixCharge = [];
      this.idCodeLkupsFixCharge   = [];
      this.rowsSelectionFixCharge = ev.selectedRows;

      this.rowsSelectionFixCharge.forEach((item) => {
        this.idCodeLkupsFixCharge.push(item.idDetailFixCharge);

      });

    },
  
    loadFixChargeItems(){
        var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
        let idBillingDetail  = idBillingDetails[0];
  
        const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-fixed-charge/"+idBillingDetail;
        this.isLoading = true;
        return this.$http
        .get(
            baseURI +
            `?limit=${this.serverFixChargeParams.per_page}&page=${this.serverFixChargeParams.page}&sort_field=${this.serverFixChargeParams.sort.field}&sort_type=${this.serverFixChargeParams.sort.type}&status=${this.serverFixChargeParams.columnFilters.status}`,
          { timeout: 10000 })
        .then((response) => {
          this.isLoading            = false;
          this.rowsFixCharge         = response.data.datas.data;
          this.totalFixChargeRecords = response.data.datas.total;
        }).catch((error) => {
            this.loading();
            
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
        });
    },

    downloadDataOvertime() {
      var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
      let idBillingDetail  = idBillingDetails[0];

      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-overtime-charge/"+idBillingDetail;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name   = "download_" + CurrentDate + ".xlsx";


      return this.$http
      .get(
        baseURI +
          `?limit=${this.serverOvertimeParams.per_page}&page=${this.serverOvertimeParams.page}&sort_field=${this.serverOvertimeParams.sort.field}&sort_type=${this.serverOvertimeParams.sort.type}&nik=${this.serverOvertimeParams.columnFilters.nik}&name=${this.serverOvertimeParams.columnFilters.name}&status=${this.serverOvertimeParams.columnFilters.status}&startOvertimeFrom=${this.startOvertimeFrom}&startOvertimeTo=${this.startOvertimeTo}&endOvertimeFrom=${this.endOvertimeFrom}&endOvertimeTo=${this.endOvertimeTo}&download=download`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },

    OvertimeChangeStatus(){
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: 'NOT BILL',
      }).then((result) => {
        if (result.value) {
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetail_Overtimes: this.idCodeLkupsOvertime,
            status: "BILL",
          }

          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-overtime-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }else{
          this.loading();
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetail_Overtimes: this.idCodeLkupsOvertime,
            status: "NOT BILL",
          }


          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-overtime-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
                this.success(response.data.datas.messages);
                this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }
      });

    },

    removeOvertimeIds() {
      this.idCodeLkupsOvertime = [];
      this.$refs['list-billing-detail-overtime'].unselectAllInternal()
    },

    onPerPageChangeOvertime(params) {
      this.updateOvertimeParams({ per_page: params.currentPerPage });
    },

    onColumnFilterOvertime(params) {
      this.updateOvertimeParams(params);
    },

    onSortChangeOvertime(params) {
      this.updateOvertimeParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    updateOvertimeParams(newProps) {
      this.serverOvertimeParams = Object.assign({}, this.serverOvertimeParams, newProps);
      this.loadOvertimeItems();
    },

    onPageChangeOvertime(params) {
      this.updateOvertimeParams({ page: params.currentPage });
    },

    selectionChangedOvertime(ev) {
      this.rowsSelectionOvertime = [];
      this.idCodeLkupsOvertime   = [];
      this.rowsSelectionOvertime = ev.selectedRows;

      this.rowsSelectionOvertime.forEach((item) => {
        this.idCodeLkupsOvertime.push(item.idDetail_Overtime);

      });

    },

    loadOvertimeItems(){
        var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
        let idBillingDetail  = idBillingDetails[0];
 
        const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-overtime-charge/"+idBillingDetail;
        this.isLoading = true;
        return this.$http
        .get(
           baseURI +
           `?limit=${this.serverOvertimeParams.per_page}&page=${this.serverOvertimeParams.page}&sort_field=${this.serverOvertimeParams.sort.field}&sort_type=${this.serverOvertimeParams.sort.type}&nik=${this.serverOvertimeParams.columnFilters.nik}&name=${this.serverOvertimeParams.columnFilters.name}&status=${this.serverOvertimeParams.columnFilters.status}&startOvertimeFrom=${this.startOvertimeFrom}&startOvertimeTo=${this.startOvertimeTo}&endOvertimeFrom=${this.endOvertimeFrom}&endOvertimeTo=${this.endOvertimeTo}`,
          { timeout: 10000 })
        .then((response) => {
          this.isLoading            = false;
          this.rowsOvertime         = response.data.datas.data;
          this.totalOvertimeRecords = response.data.datas.total;
        }).catch((error) => {
            this.loading();
            
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
        });
    },

    startOvertimeChange(){

      if(this.startOvertimeRange.startDate && this.startOvertimeRange.endDate){
        this.startOvertimeFrom=this.$moment(String(this.startOvertimeRange.startDate)).format('YYYY-MM-DD');
        this.startOvertimeTo=this.$moment(String(this.startOvertimeRange.endDate)).format('YYYY-MM-DD');
        this.loadOvertimeItems()
      }

    },


    clearstartOvertimeChange(){
      this.startOvertimeRange={
        startDate: null,
        endDate: null
      };
      this.startOvertimeFrom = ""
      this.startOvertimeTo = ""
      this.loadOvertimeItems()
    },

    endOvertimeChange(){

      if(this.endOvertimeRange.startDate && this.endOvertimeRange.endDate){
        this.endOvertimeFrom=this.$moment(String(this.endOvertimeRange.startDate)).format('YYYY-MM-DD');
        this.endOvertimeTo=this.$moment(String(this.endOvertimeRange.endDate)).format('YYYY-MM-DD');
        this.loadOvertimeItems()
      }

    },


    clearendOvertimeChange(){
      this.endOvertimeRange={
        startDate: null,
        endDate: null
      };
      this.endOvertimeFrom = ""
      this.endOvertimeTo = ""
      this.loadOvertimeItems()
    },

    downloadDataVas() {
        var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
        let idBillingDetail  = idBillingDetails[0];
 
        const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-vas-charge/"+idBillingDetail;
        var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
        var file_name = "download_" + CurrentDate + ".xlsx";
 

        return this.$http
        .get(
          baseURI +
            `?limit=${this.serverVasParams.per_page}&page=${this.serverVasParams.page}&sort_field=${this.serverVasParams.sort.field}&sort_type=${this.serverVasParams.sort.type}&docNo=${this.serverVasParams.columnFilters.docNo}&docLineNo=${this.serverVasParams.columnFilters.docLineNo}&docType=${this.serverVasParams.columnFilters.docType}&sku=${this.serverVasParams.columnFilters.sku}&uom=${this.serverVasParams.columnFilters.uom}&status=${this.serverVasParams.columnFilters.status}&receiveDateFrom=${this.receiveDateVasFrom}&receiveDateTo=${this.receiveDateVasTo}&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
         
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    vasChangeStatus(){
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: 'NOT BILL',
      }).then((result) => {
        if (result.value) {
          this.isLoading = true
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailVASs: this.idCodeLkupsVas,
            status: "BILL",
          }


          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-vas-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              this.removeVasIds()
              this.success(response.data.datas.messages);
              this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });

        }else{
          this.isLoading = true
          let data = {
            idBillingHeader: this.idBillingHeader,
            idBillingDetail: this.idBillingDetail,
            idDetailVASs: this.idCodeLkupsVas,
            status: "NOT BILL",
          }

          
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-vas-charge-update-status";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              this.removeVasIds()
              this.success(response.data.datas.messages);
              this.loadDataSubDetail();
            })
            .catch((error) => {
              this.loading();
             
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
        }
      });
    },

    removeVasIds() {
      this.idCodeLkupsVas = [];
      this.$refs['list-billing-detail-vas'].unselectAllInternal()
    },

    onPerPageChangeVas(params) {
      this.updateVasParams({ per_page: params.currentPerPage });
    },

    onColumnFilterVas(params) {
      this.updateVasParams(params);
    },

    onSortChangeVas(params) {
      this.updateVasParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    updateVasParams(newProps) {
      this.serverVasParams = Object.assign({}, this.serverVasParams, newProps);
      this.loadVasItems();
    },

    onPageChangeVas(params) {
      this.updateVasParams({ page: params.currentPage });
    },

    selectionChangedVas(ev) {
      this.rowsSelectionVas = [];
      this.idCodeLkupsVas   = [];
      this.rowsSelectionVas = ev.selectedRows;

      this.rowsSelectionVas.forEach((item) => {
        this.idCodeLkupsVas.push(item.idDetailVAS);

      });

    },

    loadVasItems(){
        var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
        let idBillingDetail  = idBillingDetails[0];
 
        const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-vas-charge/"+idBillingDetail;
        this.isLoading = true;
        return this.$http
        .get(
           baseURI +
           `?limit=${this.serverVasParams.per_page}&page=${this.serverVasParams.page}&sort_field=${this.serverVasParams.sort.field}&sort_type=${this.serverVasParams.sort.type}&docNo=${this.serverVasParams.columnFilters.docNo}&docLineNo=${this.serverVasParams.columnFilters.docLineNo}&docType=${this.serverVasParams.columnFilters.docType}&sku=${this.serverVasParams.columnFilters.sku}&uom=${this.serverVasParams.columnFilters.uom}&status=${this.serverVasParams.columnFilters.status}&receiveDateFrom=${this.receiveDateVasFrom}&receiveDateTo=${this.receiveDateVasTo}`,
          { timeout: 10000 })
        .then((response) => {
          this.isLoading = false;
          this.rowsVas = response.data.datas.data;
          this.totalVasRecords = response.data.datas.total;
        }).catch((error) => {
            this.loading();
            
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
        });
    },

    receiveDateVasChange(){

      if(this.receiveDateVasRange.startDate && this.receiveDateVasRange.endDate){
        this.receiveDateVasFrom=this.$moment(String(this.receiveDateVasRange.startDate)).format('YYYY-MM-DD');
        this.receiveDateVasTo=this.$moment(String(this.receiveDateVasRange.endDate)).format('YYYY-MM-DD');
        this.loadVasItems()
      }

    },
  
  
      clearreceiveDateVasChange(){
        this.receiveDateVasRange={
          startDate: null,
          endDate: null
        };
        this.receiveDateVasFrom = ""
        this.receiveDateVasTo = ""
        this.loadVasItems()
      },

    loadDataSubDetail(){
        if(this.chargeCategory == "VAS"){
            this.loadVasItems()
        }
        if(this.chargeCategory == "OVERTIME"){
            this.loadOvertimeItems()
        }
        if(this.chargeCategory == "FIX CHARGE" || this.chargeCategory == "FIXED CHARGE" ){
            this.loadFixChargeItems()
        }
        if(this.chargeCategory == "STORAGE"){
            this.loadStorageItems()
        }
        if(this.chargeCategory == "HANDLING IN"){
            this.loadHandlingInItems()
        }
        if(this.chargeCategory == "HANDLING OUT"){
            this.loadHandlingOutItems()
        }
        if(this.chargeCategory == "MINIMUM CHARGE"){
            this.loadMinimumChargeItems()
        }
        if(this.chargeCategory == "PACKAGING MATERIAL"){
            this.loadPackagingMaterialItems()
        }
        
    },


    loadDataDetail() {
      this.isLoading = true;

      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-detail/" + this.idBillingDetail;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        this.billingDetail          = response.data.datas;
        this.amountCategory         = this.toCurrency(response.data.datas.amountCategory);
        this.isLoading              = false;

      }).catch(error => {
          this.isLoading = false;
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


      });
    },

    removeModals(){
      
      this.$modal.hide('uploadOvertime')
      this.$modal.hide('uploadVas');
      this.$modal.hide('detailRateClibilling');
      this.rateHeader.bt_billing_detail     = []
      this.rateHeader.effectiveDate         = ""
      this.rateHeader.idRateHeader          = ""
      this.rateHeader.rateName              = ""
      this.rateHeader.warehouseId           = ""
      this.rateHeader.customerId            = ""
      this.rateHeader.customerGroup         = ""
      this.rateHeader.customerSAPCode       = ""
      this.rateHeader.firstBilingDate       = ""
      this.rateHeader.effectiveFromDate     = ""
      this.rateHeader.effectiveToDate       = ""
      this.rateHeader.status                = ""
      this.rateHeader.addwho                = ""
      this.rateHeader.editwho               = ""
      this.rateDetails                      = []
      this.billingDetail.idbillingDetail    = ""
      this.billingDetail.idBillingHeader    = ""
      this.billingDetail.chargeCategory     = ""
      this.billingDetail.chargeType         = ""
      this.billingDetail.amountCategory     = 0
      this.billingDetail.addwho             = ""
      this.billingDetail.editwho            = ""
      this.billingDetail.adddate            = ""
      this.billingDetail.editdate           = ""
      this.amountCategory                   = 0
      this.formsVas.idBillingHeader         = ""
      this.formsVas.idBillingDetail         = ""
      this.formsVas.file_vas                = ""
      this.formsVas.chargeType              = ""
      this.formsOvertime.idBillingHeader    = ""
      this.formsOvertime.idBillingDetail    = ""
      this.formsOvertime.file_overtime      = ""
      this.resetForm();
      this.loadData();
      this.loadDataDetail();
      this.loadDataSubDetail();

    },

    openRateDetail(){
      this.$modal.show('detailRateClibilling')
    },

    getRateDetail(){
      this.isLoading  = true;
      var id          = this.forms.idRateHeader;
      const baseURI = this.$settings.endPointBilling + "dashboard/cli-rate/detail/" + id;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        this.isLoading  = false;
        this.rateHeader      = response.data.datas;
        this.rateDetails     = response.data.datas.bm_rate_detail;
        this.openRateDetail()
      }).catch(error => {
          this.isLoading = false;
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


        });

    },

    toCurrency (value) {
      if (typeof value !== "number") {
          return value;
      }
      var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'IDR'
      });
      return formatter.format(value);
    },

    loadData() {
      this.isLoading = true;

      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/detail/" + this.idBillingHeader;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        this.forms                  = response.data.datas;
        this.forms.transactionDate  = response.data.datas.transactionFromDate+"~"+response.data.datas.transactionToDate
        this.amountData             = this.toCurrency(response.data.datas.amount);
        this.isLoading              = false;

      }).catch(error => {
          this.isLoading = false;
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


        });
    },

      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

    backForm() {
      var idBillingHeader  = this.$onRandom(this.idBillingHeader);
      window.location.href = "/billing-cli-billing/detail/"+idBillingHeader;
    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'BillingCliController'){

          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    var idBillingHeaders = this.$onBehind(this.$route.params.idBillingHeader);
    this.idBillingHeader = idBillingHeaders[0];
    var idBillingDetails = this.$onBehind(this.$route.params.idBillingDetail);
    this.idBillingDetail = idBillingDetails[0];
    this.chargeCategory  = this.$route.params.chargeCategory;
    this.chargeType      = this.$route.params.chargeType;

    this.fetchIt();
    this.loadData();
    this.loadDataDetail();
    this.loadDataSubDetail();
  },
};
</script>
<style scoped>

</style>
